import WebFont from 'webfontloader';
import CopyController from '../controller/CopyController';
import {
  FONT_BOLD,
  FONT_BOLD_ITALIC,
  FONT_COPY,
  FONT_CSS,
  FONT_EXTRA_BOLD,
  FONT_ITALIC,
  FONT_LIGHT,
  FONT_REGULAR,
  FONT_SUBTITLE,
} from '../constants/AppConstants';
import { STATE_LOAD } from '../constants/StateConstants';
import SaveController from 'app/controller/SaveController';
import { ScaleManagerPlugin } from 'plugins/springroll/ScaleManagerPlugin';
import { CaptionsPlugin } from 'plugins/springroll/CaptionsPlugin';
import * as Const from 'app/constants/AppConstants';

export default class Boot extends Phaser.State {
  init() {
    // this.game.input.maxPointers = 1;
    // console.log('this.game.device.touch', this.game.device.touch);
    // if (this.game.device.touch) {
    //   this.game.input.mouse.stop();
    // }
  }

  /* eslint-disable max-statements */
  preload() {
    // set flags for load checking
    this.fontsReady = false;
    this.loadComplete = false;

    this.audioSprites = [];

    // game assets
    this.game.load.baseURL = this.game.urls.getAssetsDirectory();
    this.game.load.crossOrigin = 'anonymous';
    this.game.load.pack('boot', 'assetpack.json', null, this);
    this.game.load.pack('load', 'characters/elinor/assetpack.json', null, this);

    WebFont.load({
      custom: {
        families: [
          FONT_COPY,
          FONT_SUBTITLE,
          FONT_REGULAR,
          FONT_ITALIC,
          FONT_EXTRA_BOLD,
          FONT_BOLD,
          FONT_BOLD_ITALIC,
          FONT_LIGHT,
        ],
        urls: [this.game.urls.getFontsDirectory(FONT_CSS)],
      },
      active: this.fontsLoaded.bind(this),
      inactive: this.fontsLoaded.bind(this),
    });

    // register plugins
    this.game.springRollScaleManagerPlugin = this.game.plugins.add(
      new ScaleManagerPlugin(this.game, this.game.plugins, {
        width: Const.GAME_WIDTH_DEFAULT,
        height: Const.GAME_HEIGHT_DEFAULT,
        safeWidth: Const.GAME_SAFE_WIDTH,
        safeHeight: Const.GAME_SAFE_HEIGHT,
      })
    );

    this.game.springRollCaptionsPlugin = this.game.plugins.add(
      new CaptionsPlugin(this.game, this.game.plugins)
    );
    // disable captions
    this.game.springRollCaptionsPlugin.setMute(true);

    //
    this.game.load.onFileStart.add(this.handleFileStart, this);

    // extended Phaser.Loader function to support 'spine' type in assetpack
    Phaser.Loader.prototype.processPack = function(pack) {
      const packData = pack.data[pack.key];

      if (!packData) {
        console.warn('Phaser.Loader - ' + pack.key + ': pack has data, but not for pack key');
        return;
      }

      for (let i = 0; i < packData.length; i++) {
        const file = packData[i];

        switch (file.type) {
          case 'image':
            this.image(file.key, file.url, file.overwrite);
            break;

          case 'text':
            this.text(file.key, file.url, file.overwrite);
            break;

          case 'json':
            this.json(file.key, file.url, file.overwrite);
            break;

          case 'xml':
            this.xml(file.key, file.url, file.overwrite);
            break;

          case 'script':
            this.script(file.key, file.url, file.callback, pack.callbackContext || this);
            break;

          case 'binary':
            this.binary(file.key, file.url, file.callback, pack.callbackContext || this);
            break;

          case 'spritesheet':
            this.spritesheet(
              file.key,
              file.url,
              file.frameWidth,
              file.frameHeight,
              file.frameMax,
              file.margin,
              file.spacing,
              file.skipFrames
            );
            break;

          case 'video':
            this.video(file.key, file.urls);
            break;

          case 'audio':
            this.audio(file.key, file.urls, file.autoDecode);
            break;

          case 'audiosprite':
            this.audiosprite(file.key, file.urls, file.jsonURL, file.jsonData, file.autoDecode);
            break;

          case 'tilemap':
            this.tilemap(file.key, file.url, file.data, Phaser.Tilemap[file.format]);
            break;

          case 'physics':
            this.physics(file.key, file.url, file.data, Phaser.Loader[file.format]);
            break;

          case 'bitmapFont':
            this.bitmapFont(
              file.key,
              file.textureURL,
              file.atlasURL,
              file.atlasData,
              file.xSpacing,
              file.ySpacing
            );
            break;

          case 'atlasJSONArray':
            this.atlasJSONArray(file.key, file.textureURL, file.atlasURL, file.atlasData);
            break;

          case 'atlasJSONHash':
            this.atlasJSONHash(file.key, file.textureURL, file.atlasURL, file.atlasData);
            break;

          case 'atlasXML':
            this.atlasXML(file.key, file.textureURL, file.atlasURL, file.atlasData);
            break;

          case 'atlas':
            this.atlas(
              file.key,
              file.textureURL,
              file.atlasURL,
              file.atlasData,
              Phaser.Loader[file.format]
            );
            break;

          case 'shader':
            this.shader(file.key, file.url, file.overwrite);
            break;

          case 'spine':
            this.spine(file.key, file.url);
            break;
        }
      }
    };

    // fix for spine loader
    /* PhaserSpine.SpinePlugin.prototype.addSpineLoader = function() {
      Phaser.Loader.prototype.spine = function(key, url, scalingVariants) {
        scalingVariants;
        const path = url.substr(0, url.lastIndexOf('.'));
        const filenameonly = url.substring(url.lastIndexOf('/') + 1, url.lastIndexOf('.'));
        this.text('atlas_' + PhaserSpine.SpinePlugin.SPINE_NAMESPACE + '_' + key, path + '.atlas');
        this.json(PhaserSpine.SpinePlugin.SPINE_NAMESPACE + key, path + '.json');
        this.image(filenameonly + '.png', path + '.png');
      };
    };*/

    // fix for animation after pause game
    /* window.spine.AnimationState.prototype.update = function(delta) {
      delta = Math.min(0.1, delta); // this is fix
      delta *= this.timeScale;
      const tracks = this.tracks;
      for (let i = 0, n = tracks.length; i < n; i++) {
        const current = tracks[i];
        if (!current) continue;
        current.animationLast = current.nextAnimationLast;
        current.trackLast = current.nextTrackLast;
        let currentDelta = delta * current.timeScale;
        if (current.delay > 0) {
          current.delay -= currentDelta;
          if (current.delay > 0) continue;
          currentDelta = -current.delay;
          current.delay = 0;
        }
        let next = current.next;
        if (next) {
          const nextTime = current.trackLast - next.delay;
          if (nextTime >= 0) {
            next.delay = 0;
            next.trackTime = nextTime + delta * next.timeScale;
            current.trackTime += currentDelta;
            this.setCurrent(i, next, true);
            while (next.mixingFrom) {
              next.mixTime += currentDelta;
              next = next.mixingFrom;
            }
            continue;
          }
        } else if (current.trackLast >= current.trackEnd && !current.mixingFrom) {
          tracks[i] = null;
          this.queue.end(current);
          this.disposeNext(current);
          continue;
        }
        if (current.mixingFrom && this.updateMixingFrom(current, delta)) {
          let from = current.mixingFrom;
          current.mixingFrom = null;
          while (from) {
            this.queue.end(from);
            from = from.mixingFrom;
          }
        }
        current.trackTime += currentDelta;
      }
      this.queue.drain();
    };*/

    //
    this.game.add.plugin(PhaserSpine.SpinePlugin, {
      triangleRendering: true,
      debugRendering: false,
    });
  }
  /* eslint-enable */

  handleFileStart(progress, key, url) {
    progress;
    key;
    url;
    // store audioatlse names to add them to sound manager
    if (key.indexOf('-audioatlas') !== -1) {
      this.audioSprites.push(key.replace('-audioatlas', ''));
    }
  }

  fontsLoaded() {
    this.fontsReady = true;
  }

  create() {
    this.game.copy = new CopyController(this.game, this.game.cache.getXML('copy_xml'));
    this.game.saves = new SaveController({ game: this });
    // todo : touch event flag for this?
    this.game.isTouch =
      'ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

    this.loadComplete = true;

    // register audiosprites
    for (let i = 0; i < this.audioSprites.length; i++) {
      if (this.game.cache.checkSoundKey(this.audioSprites[i])) {
        this.game.sounds.addAudioSprite({ id: this.audioSprites[i] });
      }
    }
  }

  update() {
    this.checkLoading();
  }

  checkLoading() {
    if (this.loadComplete && this.fontsReady) {
      this.game.state.start(STATE_LOAD, true, false);
    }
  }
}
